<!--
 * @Author: 李明明
 * @Date: 2024-02-29 09:00:53
 * @LastEditTime: 2024-02-29 16:20:35
 * @LastEditors: 李明明
 * @Description: 
 * @FilePath: /pc用户端/jctt-pc/src/views/user/components/SelectInvoicePop.vue
 * 代码版权方：'政府采购信息网'
-->
<!-- 发票选择弹窗 -->
<template>
  <div>
    <el-dialog title="发票信息" :visible.sync="invoiceVisible" width="500px" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false" center class="invoice_pop">
      <div class="add_invoice">
        <el-button type="text" @click="ClickAddInvoice" style="">新增发票抬头</el-button>

      </div>

      <el-tabs v-model="invoiceType" @tab-click="handleInvoiceTabs">
        <el-tab-pane label="公司" name="2"></el-tab-pane>
        <el-tab-pane label="个人" name="1"></el-tab-pane>
        <ul class="invoice_list" v-if="invoiceList.length > 0">
          <li v-for="item in invoiceList" :key="item.id" @click="SelectInvoice(item)" :class="item.isActive ? 'active': ''">
            <h3 class="invoice_header">{{ item.header }}</h3>
            <div class="invoice_info">
              <p class="invoice_taxpayer">税号：{{ item.taxpayer }}</p>
              <p class="invoice_type">发票类型：{{ item.invoice_type == 2 ? '增值税专用发票' : '增值税普通发票' }}</p>
            </div>
          </li>
        </ul>
        <el-empty v-else description="无发票信息"></el-empty>

      </el-tabs>
      <span slot="footer">
        <el-button type="primary" @click="CloseInvoicePop">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 专用发票无法选择提示 -->
    <el-dialog title="提示" :visible.sync="invoiceTipVisible" width="30%" center>
      <p style="font-size: 14px;">
        当前商品不支持开具增值税专用发票，如需帮助请联系：010-88811106
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button class="invoice_tip_btn" type="primary" @click="invoiceTipVisible = false">知道了</el-button>
      </span>
    </el-dialog>
    <!-- 新增发票抬头弹窗 -->
    <AddInvoice :addInvoiceVisible="addInvoiceVisible" :invoiceType="invoiceType" @CloseAddInvoice="CloseAddInvoice" @SaveInvoice="SaveInvoice"></AddInvoice>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import AddInvoice from './addInvoice.vue'
export default {
  name: "SelectInvoicePop",
  props: ['invoiceVisible','selectInoiceData'],
  // import引入的组件需要注入到对象中才能使用
  components: {AddInvoice},
  data () {
    // 这里存放数据
    return {
      invoiceType: '2',
      invoiceList: [],  // 发票列表
      invoiceTipVisible: false,  // 专票无法选择提示弹窗
      addInvoiceVisible: false,  // 发票抬头新增弹窗是否显示
    };
  },
  // 监听属性 类似于data概念
  computed: {

  },
  // 监控data中的数据变化
  watch: {
    invoiceVisible: {
      handler (val) {
        if (val) {
          console.log(this);
          this.getInvoiceList(2)
        }
      }
    }
  },
  // 方法集合
  methods: {
    /**
     * @description: 切换发票类型
     * @return {*}
     */
    handleInvoiceTabs () {
      console.log(this.invoiceType);
      this.getInvoiceList(this.invoiceType)
    },
    /**
     * @description: 获取发票列表数据
     * @return {*}
     */
    getInvoiceList (invoiceType) {
      this.$api
        .getinvoivelist({
          type: invoiceType
        })
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            this.invoiceList = res.data.list;
          console.log('一选中发票',this.selectInoiceData);
          this.invoiceList.forEach(item=>{
            if(item.id == this.selectInoiceData.id){
              item.isActive = true;
            }
          })
          } else {
            this.$message({
              message: "" + res.msg,
              type: "warning",
            });
            this.invoiceList = [];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**
     * @description: 选择发票抬头
     * @param {*
     *  data: 发票抬头数据
     * }
     * @return {*}
     */
    SelectInvoice (data) {
      if (data.invoice_type != 2) {
        this.$emit('PitchInvoice', data)
        this.invoiceType = '2'
      } else {
        this.invoiceTipVisible = true;
      }
    },
    /**
     * @description: 点击新增发票抬头弹窗
     * @return {*}
     */    
    ClickAddInvoice(){
      this.addInvoiceVisible = true
    },
    /**
     * @description: 关闭发票新增弹窗
     * @return {*}
     */    
    CloseAddInvoice(){
      this.addInvoiceVisible = false
    },
    /**
     * @description: 发票新增成功
     * @return {*}
     */    
    SaveInvoice(){
      this.addInvoiceVisible = false
      this.getInvoiceList(this.invoiceType)
    },
    /**
     * @description: 关闭发票选择弹窗
     * @return {*}
     */
    CloseInvoicePop () {
      this.invoiceType = '2'
      this.$emit('CloseInvoicePop')
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss'>
// @import url(); 引入公共css类
.invoice_pop {
  .el-dialog__body {
    padding: 0 20px 30px 20px;
  }

  .add_invoice {
    overflow: hidden;

    .el-button {
      float: right;

      span {
        color: #409eff !important;
      }
      &:hover{
        opacity: .6;
      }
    }
  }

  .invoice_list {
    min-height: 300px;

    li {
      padding: 16px;
      border: 1px solid #dbdbdb;
      cursor: pointer;
      box-sizing: border-box;
      margin: 8px 0;
      display: inline-block;
      width: 100%;
      .invoice_header {
        font-size: 16px;
      }

      .invoice_info {
        margin-top: 14px;

        p {
          display: inline-block;
        }

        .invoice_type {
          margin-left: 20px;
        }
      }
    }
    .active{
      border: 1px solid #df3031;
    }
  }
}
</style>